import { render, staticRenderFns } from "./direct-sales-list-clients.vue?vue&type=template&id=5af57869&scoped=true"
import script from "./direct-sales-list-clients.vue?vue&type=script&lang=ts"
export * from "./direct-sales-list-clients.vue?vue&type=script&lang=ts"
import style0 from "./direct-sales-list-clients.vue?vue&type=style&index=0&id=5af57869&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af57869",
  null
  
)

export default component.exports